export const theme = {
    colors: {
        accent: '#1238bf',
        accentLighter: '#143fe5',
        primary: '#2E2E2E',
        disabled: '#F1F1F1',
    },
};
